import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
function BillingPdf() {
    const { order_id } = useParams();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`billing/order/get_bill_details/${order_id}`);
                setData(res.data);

                // Trigger print after small delay
                setTimeout(() => window.print(), 500);
            } catch (err) {
                setError("Failed to fetch bill data or bill not completed.");
                console.error(err);
            }
        };
        fetchData();
    }, [order_id]);

    if (error) return <div className="p-4 text-red-500">{error}</div>;
    if (!data) return <div className="p-4">Loading...</div>;
    const totalQuantity = data.items.reduce((sum, item) => sum + item.quantity, 0);
    const totalAmount = data.items.reduce((sum, item) => sum + item.quantity * item.price, 0);

    return (
        <div className="p-4 print:p-0 print:m-0 print:scale-100">
            <div className="relative mb-4">
                {/* Centered Headings */}
                <div className="text-center">
                    <h1 className="text-2xl font-bold">BEST FASHIONS</h1>
                    <h3 className="text-xl font-bold">Invoice</h3>
                </div>

                {/* Go Back Button on the right */}
                <button
                    onClick={() => navigate("/billing")}
                    className="absolute right-0 top-1 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 print:hidden"
                >
                    Go Back
                </button>
            </div>

            <div className="grid grid-cols-2 gap-8 text-sm mb-4 px-20">
                {/* Left Side (Buyer Info) */}
                <div className="space-y-1">
                    <div className="flex">
                        <span className="w-32 font-semibold">Buyer Name</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.buyer_name}</span>
                    </div>
                    <div className="flex">
                        <span className="w-32 font-semibold">Phone</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.buyer_phone}</span>
                    </div>
                    <div className="flex">
                        <span className="w-32 font-semibold">GST No</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.buyer_gst}</span>
                    </div>
                    {/* <div className="flex">
                        <span className="w-32 font-semibold">GST Type</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.buyer_gst_type}</span>
                    </div> */}
                    <div className="flex">
                        <span className="w-32 font-semibold">Address</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.buyer_address}</span>
                    </div>
                </div>

                {/* Right Side (Order Info) */}
                <div className="space-y-1 ml-10">
                    <div className="flex">
                        <span className="w-32 font-semibold">Order No</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.cut_order_no}</span>
                    </div>
                    <div className="flex">
                        <span className="w-32 font-semibold">Style</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.style_name}</span>
                    </div>
                    <div className="flex">
                        <span className="w-32 font-semibold">Total Pieces</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{data.total_piece}</span>
                    </div>
                    <div className="flex">
                        <span className="w-32 font-semibold">Order Date</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{new Date(data.order_date).toLocaleDateString()}</span>
                    </div>
                    {/* <div className="flex">
                        <span className="w-32 font-semibold">Delivery Date</span>
                        <span className="w-1 mr-2">:</span>
                        <span className="flex-1">{new Date(data.delivery_date).toLocaleDateString()}</span>
                    </div> */}
                </div>
            </div>


            <table className="w-full border border-collapse text-sm">
                <thead>
                    <tr>
                        <th className="border p-2">Color</th>
                        <th className="border p-2">Size</th>
                        <th className="border p-2">Quantity</th>
                        <th className="border p-2">Price</th>
                        <th className="border p-2">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {data.items.map((item, idx) => {
                        const amount = item.quantity * item.price;
                        return (
                            <tr key={idx}>
                                <td className="border p-2">{item.colour_name}</td>
                                <td className="border p-2">{item.size_name}</td>
                                <td className="border p-2 text-right">{item.quantity}</td>
                                <td className="border p-2 text-right">₹{item.price.toFixed(2)}</td>
                                <td className="border p-2 text-right">₹{amount.toFixed(2)}</td>
                            </tr>
                        );
                    })}
                    {/* Totals Row */}
                    <tr className="font-semibold">
                        <td className="border p-2 text-center" colSpan={2}>Total</td>
                        <td className="border p-2 text-right">{totalQuantity}</td>
                        <td className="border p-2"></td>
                        <td className="border p-2 text-right">₹{totalAmount.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default BillingPdf;
